"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var app_1 = __importDefault(require("firebase/app"));
var moment_1 = __importDefault(require("moment"));
function getDateForCell(timestamp, mode) {
    if (timestamp instanceof Date) {
        return mode === 'view' ? timestamp : (0, moment_1.default)(timestamp);
    }
    if (timestamp instanceof app_1.default.firestore.Timestamp || moment_1.default.isMoment(timestamp)) {
        var date = timestamp === null || timestamp === void 0 ? void 0 : timestamp.toDate();
        return mode === 'view' ? date : (0, moment_1.default)(date);
    }
    return timestamp;
}
exports.default = getDateForCell;
